import { useEffect, useRef } from "react"
import logo from "utils/stylesheets/logo/logo.png"
import Message from "./Message"

export default function MessageList({ messages, loaderVisible }) {
  const endRef = useRef(null)

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [messages, loaderVisible])

  return (
    <div className="chatbot-widget-messages">
      {messages.map((msg) => {
        if (msg.sender === "custom") {
          const Comp = msg.component
          return (
            <div key={msg.id} className="chatbot-widget-custom-message">
              <Comp {...(msg.props || {})} />
            </div>
          )
        }
        return <Message key={msg.id} sender={msg.sender} text={msg.text} attachments={msg.attachments} />
      })}
      {loaderVisible && (
        <div className="chat-message-container bot-message">
          <div className="chat-message-icon">
            <img src={logo} alt="" className="librarian-logo" />
          </div>
          <div className="chat-message thinking-dots" />
        </div>
      )}
      <div ref={endRef} />
    </div>
  )
}
